import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

import { OrganizationDetail } from './organization-detail';
import { OrganizationList } from './organization-list';

export const OrganizationRoutes: RouteObject[] = [
  {
    path: ROUTES_PATH.organizationList,
    children: [
      { index: true, element: <OrganizationList /> },
      { path: 'new', lazy: () => import('./organization-new') },
      { path: 'acode-update', lazy: () => import('./acode-update') },
      { path: ':id', element: <OrganizationDetail /> },
      {
        path: ':id/accounts',
        children: [
          { path: 'new', lazy: () => import('./organization-account-new') },
          {
            path: ':accountId',
            lazy: () => import('./organization-account-detail'),
          },
        ],
      },
      {
        path: ':id/shops',
        children: [
          { path: 'new', lazy: () => import('./organization-shop-new') },
          {
            path: ':shopId',
            lazy: () => import('./organization-shops-detail'),
          },
        ],
      },
      {
        path: ':id/shops/weddings',
        children: [
          { path: 'new', lazy: () => import('./organization-shop-new') },
          {
            path: ':shopId',
            lazy: () => import('./organization-shops-detail'),
          },
        ],
      },
      {
        path: ':id/printer-and-fixtures',
        children: [
          { path: 'new', lazy: () => import('./printer-and-fixtures-new') },
          {
            path: ':fixtureId',
            lazy: () => import('./printer-and-fixtures-detail'),
          },
        ],
      },
      {
        path: ':id/drink-materials',
        children: [
          { path: 'new', lazy: () => import('./drink-materials-new') },
          {
            path: ':materialId',
            lazy: () => import('./drink-materials-detail'),
          },
        ],
      },
    ],
  },
  {
    path: ROUTES_PATH.myOrganization,
    children: [
      { index: true, element: <OrganizationDetail /> },
      {
        path: 'accounts',
        children: [
          { path: 'new', lazy: () => import('./organization-account-new') },
          {
            path: ':accountId',
            lazy: () => import('./organization-account-detail'),
          },
        ],
      },
      {
        path: 'shops',
        children: [
          { path: 'new', lazy: () => import('./organization-shop-new') },
          {
            path: ':shopId',
            lazy: () => import('./organization-shops-detail'),
          },
        ],
      },
      {
        path: 'shops/weddings',
        children: [
          { path: 'new', lazy: () => import('./organization-shop-new') },
          {
            path: ':shopId',
            lazy: () => import('./organization-shops-detail'),
          },
        ],
      },
      {
        path: 'drink-materials',
        children: [
          { path: 'new', lazy: () => import('./drink-materials-new') },
          {
            path: ':materialId',
            lazy: () => import('./drink-materials-detail'),
          },
        ],
      },
    ],
  },
];
